/* eslint-disable quote-props */
// @mui

import i18n from 'i18';
import config from 'config';
import helper from 'utils/helper';
import { MenuItem, Typography, Select } from '@mui/material';
// ----------------------------------------------------------------------

export default function LanguagePopover() {
    const langs = config.languages;

    const selectedLanguage =
        langs.find((l) => l === i18n.resolvedLanguage) ||
        langs.find((l) => l === config.language);

    return (
        <Select
            value={selectedLanguage}
            onChange={(e) => helper.changeLanguage(e.target.value)}
            sx={{
                height: '32px',
                minHeight: '32px',
                '& .MuiSelect-select': {
                    paddingTop: '4px',
                    paddingBottom: '4px',
                    paddingLeft: '12px',
                    paddingRight: '32px', // Space for dropdown arrow
                    fontSize: '14px',
                    fontWeight: 600, // Semi-bold
                    color: '#344054', // Dark gray text
                    display: 'flex',
                    alignItems: 'center'
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#E0E0E0', // Light gray border
                    borderRadius: '8px'
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#BDBDBD'
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#91733D' // Purple underline color
                },
                '& .MuiSelect-icon': {
                    color: '#424242', // Dark gray arrow
                    fontSize: '18px', // Increased from 16px to 18px
                    fontWeight: 700, // Added bold weight to arrow
                    transform: 'scale(1.2)' // Make arrow slightly larger
                }
            }}
        >
            {langs.map((lang) => (
                <MenuItem key={lang} value={lang}>
                    <Typography variant="subtitle2">
                        {i18n.t(`langs.${lang}`)}
                    </Typography>
                </MenuItem>
            ))}
        </Select>
    );
}
